module.exports = __webpack_public_path__ + "img/zh_cn.6066468c.png";